import { __extends } from "tslib";
import { TicketPriority } from './enums/ticket-priority.enum';
import { UserInfoBuilder } from './user-info.builder';
import { TicketBuilder } from './ticket.builder';
var ExtendedTicketBuilder = /** @class */ (function (_super) {
    __extends(ExtendedTicketBuilder, _super);
    function ExtendedTicketBuilder() {
        var _this = _super.call(this) || this;
        _this.item.userInfo = new UserInfoBuilder().build();
        _this.item.priority = TicketPriority.NORMAL;
        _this.item.excludedFromHelpCenterContentScope = false;
        _this.item.relatedArticleIds = [];
        _this.item.spam = false;
        _this.item.createdOnBehalf = false;
        _this.item.createdByAgent = undefined;
        _this.item.unansweredRepliesCount = 0;
        _this.item.handlingUsers = [];
        _this.item.handlingUserIds = [];
        return _this;
    }
    ExtendedTicketBuilder.prototype.withUserInfo = function (info) {
        this.item.userInfo = info;
        return this;
    };
    ExtendedTicketBuilder.prototype.withCreatedByAgent = function (p) {
        this.item.createdByAgent = p;
        return this;
    };
    ExtendedTicketBuilder.prototype.withPriority = function (p) {
        this.item.priority = p;
        return this;
    };
    ExtendedTicketBuilder.prototype.withSpam = function (spam) {
        this.item.spam = spam;
        return this;
    };
    ExtendedTicketBuilder.prototype.withCreatedOnBehalf = function (createdOnBehalf) {
        this.item.createdOnBehalf = createdOnBehalf;
        return this;
    };
    ExtendedTicketBuilder.prototype.withChannelData = function (data) {
        this.item.channelData = data;
        return this;
    };
    ExtendedTicketBuilder.prototype.withRelatedArticleIds = function (ids) {
        this.item.relatedArticleIds = ids;
        return this;
    };
    ExtendedTicketBuilder.prototype.withRawEmail = function (rawEmailAvailable) {
        this.item.rawEmailAvailable = rawEmailAvailable;
        return this;
    };
    ExtendedTicketBuilder.prototype.withLastReply = function (lastReply) {
        this.item.lastReply = lastReply;
        return this;
    };
    ExtendedTicketBuilder.prototype.withUnansweredRepliesCount = function (unansweredRepliesCount) {
        this.item.unansweredRepliesCount = unansweredRepliesCount;
        return this;
    };
    ExtendedTicketBuilder.prototype.withCompanyId = function (companyId) {
        this.item.companyId = companyId;
        return this;
    };
    ExtendedTicketBuilder.prototype.withSnoozeData = function (snoozeData) {
        this.item.snooze = snoozeData;
        return this;
    };
    ExtendedTicketBuilder.prototype.withPrimaryTicket = function (primaryTicketId) {
        this.item.primaryTicketId = primaryTicketId;
        return this;
    };
    ExtendedTicketBuilder.prototype.withAllCcUsers = function (allCcUsers) {
        this.item.allCcUsers = allCcUsers;
        return this;
    };
    ExtendedTicketBuilder.prototype.withAssignedUser = function (assignedUser) {
        this.item.assignedUser = assignedUser;
        return this;
    };
    ExtendedTicketBuilder.prototype.withCustomFields = function (customFields) {
        this.item.customFields = customFields;
        return this;
    };
    ExtendedTicketBuilder.prototype.withHandlingUsers = function (users) {
        this.item.handlingUsers = users;
        return this;
    };
    ExtendedTicketBuilder.prototype.withOriginCallbackTicketId = function (id) {
        this.item.originCallbackTicketId = id;
        return this;
    };
    ExtendedTicketBuilder.prototype.withHandlingUserIds = function (handlingUserIds) {
        this.item.handlingUserIds = handlingUserIds;
        return this;
    };
    ExtendedTicketBuilder.prototype.withBrandID = function (brandID) {
        this.item.brandId = brandID;
        return this;
    };
    ExtendedTicketBuilder.prototype.withLocale = function (locale) {
        this.item.locale = locale;
        return this;
    };
    ExtendedTicketBuilder.prototype.build = function () {
        return this.item;
    };
    return ExtendedTicketBuilder;
}(TicketBuilder));
export { ExtendedTicketBuilder };
//# sourceMappingURL=extended-ticket.builder.js.map